package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.tech.ui.TechPage

/**
 * initTechRoute
 * Registers page layout data for the /tech route.
 *
 * @param ctx Kobweb route initialisation context.
 */
@InitRoute
fun initTechRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Tech"))
}

/**
 * TechRoute
 * Kobweb page entry point for the /tech route — renders [TechPage].
 */
@Page(routeOverride = "tech")
@Layout(".components.layouts.PageLayout")
@Composable
fun TechRoute() {
    TechPage()
}
